import styled from 'styled-components';
export const CollapseWrapper = styled.div `
  display: grid;
  grid-template-rows: 0fr;
  overflow: auto;
  transition: ${({ duration }) => {
    return `grid-template-rows ${duration}ms ease`;
}};
`;
export const CollapseContent = styled.div `
  overflow: hidden;
`;
